var map = {
	"./404.svg": "a14a",
	"./baseInfo.svg": "c65b",
	"./bug.svg": "1779",
	"./chart.svg": "c829",
	"./clear.svg": "85b3",
	"./clipboard.svg": "bc35",
	"./component.svg": "56d6",
	"./consum.svg": "4a43",
	"./dashboard.svg": "f782",
	"./documentation.svg": "90fb",
	"./drag.svg": "9bbf",
	"./edit.svg": "aa46",
	"./education.svg": "ad1c",
	"./email.svg": "cbb7",
	"./equipment.svg": "b596",
	"./example.svg": "30c3",
	"./excel.svg": "6599",
	"./exit-fullscreen.svg": "dbc7",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./fullscreen.svg": "9921",
	"./guide.svg": "6683",
	"./huiyishi.svg": "d2bc",
	"./icon.svg": "9d91",
	"./inoutStockDetail.svg": "48fd",
	"./international.svg": "17df",
	"./itemCategory.svg": "f07a",
	"./language.svg": "2580",
	"./left.svg": "d977",
	"./link.svg": "18f0",
	"./list.svg": "3289",
	"./location.svg": "1c50",
	"./lock.svg": "ab00",
	"./markers.svg": "e107",
	"./medium.svg": "5de0",
	"./message.svg": "47ff",
	"./money.svg": "3046",
	"./nested.svg": "dcf8",
	"./open.svg": "ace4",
	"./other.svg": "5f34",
	"./password.svg": "2a3d",
	"./pay.svg": "4415",
	"./pdf.svg": "f9a1",
	"./people.svg": "d056",
	"./peoples.svg": "2f11",
	"./personal.svg": "ce9e",
	"./purchase.svg": "b8f7",
	"./qq.svg": "1430",
	"./reagent.svg": "6bc6",
	"./right.svg": "9a71",
	"./sample.svg": "f148",
	"./search.svg": "8e8d",
	"./shopping.svg": "12a5",
	"./size.svg": "8644",
	"./skill.svg": "096e",
	"./star.svg": "708a",
	"./sysSetting.svg": "3a71",
	"./tab.svg": "8fb7",
	"./table.svg": "47f1",
	"./test.svg": "fe8d",
	"./theme.svg": "e534",
	"./tree-table.svg": "e7c8",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5",
	"./wechat.svg": "80da",
	"./zip.svg": "8aa6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";